import React, { useEffect, useState } from 'react';
import client from '../../api/client.js';
import Table from '../../layout/admin/Table.js';
import Spinner from '../Global/Spinner.js';
export default function Messages() {
	const [messages, setMessages] = useState([]);
	const [loading, setLoading] = useState(false);
	const [showModal, setShowModal] = useState(false);

	const toggleModal = () => {
		setShowModal(!showModal);
	};
	const getMessages = async () => {
		setLoading(true);
		const { data } = await client.get('/message');
		console.log({ data });
		setMessages(data.messages);
		setLoading(false);
	};

	useEffect(() => {
		getMessages();
	}, []);
	if (loading) return <Spinner />;
	return (
		<div>
			<Table
				data={messages}
				title='Messages'
			/>
		</div>
	);
}
